import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'
import { useCsrfToken } from '@/Hooks/Shared/useCsrfToken.js'
import { useCookies } from '@vueuse/integrations/useCookies'
import axios from 'axios'

export function useImpersonation() {
  const { csrfToken } = useCsrfToken()
  const page = usePage()
  const cookies = useCookies()

  const impersonation = computed(() => page.props.auth?.impersonation)
  const isImpersonating = computed(() => impersonation.value && cookies.get('nova_impersonated_id'))
  const impersonationHasChanged = computed(
    () =>
      isImpersonating.value &&
      impersonation.value?.impersonated.id !== cookies.get('nova_impersonated_id')
  )

  const startImpersonating = (impersonate) => {
    axios
      .create({
        withCredentials: true,
        headers: {
          'X-CSRF-TOKEN': csrfToken.value,
        },
      })
      .post(route('nova.api.start-nova-impersonation'), {
        resource: impersonate.resource,
        resourceId: impersonate.resourceId,
        redirect: impersonate.redirect ?? null,
        company: impersonate.companyId ?? null,
      })
      .then((response) => {
        window.location.href = response.data.redirect
      })
  }

  const stopImpersonating = () => {
    window.dispatchEvent(new Event('stoppingImpersonation'))

    axios
      .create({
        withCredentials: true,
        headers: {
          'X-CSRF-TOKEN': csrfToken.value,
        },
      })
      .delete(route('nova.api.stop-nova-impersonation'), {
        _token: csrfToken.value,
        _method: 'DELETE',
      })
      .then((response) => (window.location.href = response.data.redirect))
  }

  return {
    impersonation,
    impersonationHasChanged,
    isImpersonating,
    startImpersonating,
    stopImpersonating,
  }
}
